import { EntityListWithPagination, PaginacionRequest } from 'src/types'
import { HttpAxiosRequest } from '../httpAxiosBase'
import { Mensaje, MensajeDetalle } from '../../pages/messages/types'
import { MensajesRequestDTO } from 'src/pages/messages/api/schemas'

export const HttpMessages = {
    getEndpoint: (url = ''): string => `workflow/mensajes${url}`,

    getByUser: (
        parametros: MensajesRequestDTO,
        paginacion: PaginacionRequest
    ): Promise<EntityListWithPagination<Mensaje>> => {
        return HttpAxiosRequest.getWithQueryParamsSerializer(HttpMessages.getEndpoint(), {
            ...parametros,
            ...paginacion
        })
    },

    getDetail: (mensajeId: number): Promise<MensajeDetalle> => {
        return HttpAxiosRequest.get(HttpMessages.getEndpoint(`/${mensajeId}`))
    },

    closeMessage: (messageId: number): Promise<void> => {
        return HttpAxiosRequest.post(HttpMessages.getEndpoint(`/${messageId}/cerrar`), {})
    },

    cancelMessage: (messageId: number): Promise<void> => {
        return HttpAxiosRequest.post(HttpMessages.getEndpoint(`/${messageId}/anular`), {})
    }
} as const
